import { useState } from "react";
import { MdArrowForwardIos } from "react-icons/md";
import LASTIMG from "../../../Assets/CareersImg/CarrersLastImg.png";

const FaqSectionService = ({ faqs }) => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleDropdown = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* Glow orbs */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/25 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          {/* LEFT FAQ */}
          <div className="w-full lg:w-[55%] space-y-4" data-aos="fade-right">
            <p className="text-[10px] text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#064585]">
              Support & Help
            </p>
            <h1 className="mt-2 text-3xl md:text-4xl font-semibold text-slate-900">
              Frequently Asked{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
                Questions
              </span>
            </h1>
            <p className="mt-3 text-slate-600 text-sm sm:text-base md:text-lg">
              Get instant answers to common questions about our courses,
              internships, and live projects.
            </p>

            <div className="mt-4 space-y-4">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className="bg-white/80 backdrop-blur rounded-2xl border border-[#5989C8]/20 shadow-sm hover:shadow-md transition-shadow"
                >
                  {/* Question row */}
                  <button
                    type="button"
                    onClick={() => toggleDropdown(faq.id)}
                    className="w-full px-4 md:px-5 py-3 md:py-4 flex items-center justify-between text-left"
                  >
                    <h2
                      className={`text-sm md:text-base font-medium ${
                        openFAQ === faq.id ? "text-[#064585]" : "text-slate-900"
                      }`}
                    >
                      {faq.question}
                    </h2>
                    <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#eef3ff] text-[#064585]">
                      <MdArrowForwardIos
                        className={`transition-transform duration-300 ${
                          openFAQ === faq.id ? "rotate-90" : "rotate-0"
                        }`}
                        size={16}
                      />
                    </div>
                  </button>

                  {/* answer */}
                  <div
                    className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-out ${
                      openFAQ === faq.id
                        ? "max-h-40 md:max-h-48 opacity-100 pb-4 md:pb-5 border-t border-[#5989C8]/15"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="pt-3 text-[12px] md:text-sm font-light text-slate-700">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div
            className="w-full lg:w-[45%] flex flex-col items-center lg:items-end text-center lg:text-right"
            data-aos="fade-left"
          >
            <div className="bg-white/80 backdrop-blur rounded-3xl shadow-md border border-[#5989C8]/20 p-4 w-full max-w-md">
              <img
                src={LASTIMG}
                alt="FAQ Illustration"
                className="w-full h-auto object-contain"
              />
            </div>
            <p className="mt-4 font-light text-slate-600 text-sm sm:text-base max-w-md">
              Still have questions? Reach out to our support team and we’ll help
              you pick the right path.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSectionService;
